// Types
import { TDividerType } from "./Divider.type";
import { TDividerProps } from "./index";

export const DIVIDER_TYPES: TDividerType[] = ["left", "center", "right"];
export const DIVIDER_TYPE: { [key in TDividerType]: key } = {
  left: "left",
  center: "center",
  right: "right",
};

export const DIVIDER_DEFAULT_PROPS: TDividerProps = {
  type: DIVIDER_TYPE.center,
};